// extracted by mini-css-extract-plugin
export default {"container":"style_container__K9QUl","message":"style_message__ciWCV"};